var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ps-badge",class:'ps-badge--' + _vm.badgeType},[(_vm.showIcon)?_c('span',{staticClass:"ps-badge__icon"},[_vm._v(_vm._s(_vm.iconText))]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }